import type { WizardStepProps } from '../../../../types/builder.types'
import { KPIConfiguration } from '../configurations/KPIConfiguration'
import { ChartConfiguration } from '../configurations/ChartConfiguration'
import { TableConfiguration } from '../configurations/TableConfiguration'
import { MapConfiguration } from '../configurations/MapConfiguration'
import { PieChartConfiguration } from '../configurations/PieChartConfiguration'
import { GaugeConfiguration } from '../configurations/GaugeConfiguration'
import { AreaChartConfiguration } from '../configurations/AreaChartConfiguration'
import { StackedBarConfiguration } from '../configurations/StackedBarConfiguration'
import { ScatterPlotConfiguration } from '../configurations/ScatterPlotConfiguration'
import { HeatmapConfiguration } from '../configurations/HeatmapConfiguration'
import { TreemapConfiguration } from '../configurations/TreemapConfiguration'
import { RadarChartConfiguration } from '../configurations/RadarChartConfiguration'
import { RadialBarConfiguration } from '../configurations/RadialBarConfiguration'

export function ConfigurationStep(props: WizardStepProps) {
  const { config } = props

  // Router: renderiza la configuración específica según el tipo de componente
  switch (config.componentType) {
    case 'kpi':
      return <KPIConfiguration {...props} />

    case 'line-chart':
    case 'bar-chart':
      return <ChartConfiguration {...props} />

    case 'table':
      return <TableConfiguration {...props} />

    // Geográficos
    case 'map':
      return <MapConfiguration {...props} />

    // Distribución
    case 'pie-chart':
      return <PieChartConfiguration {...props} />

    case 'treemap':
      return <TreemapConfiguration {...props} />

    // Indicadores
    case 'gauge':
      return <GaugeConfiguration {...props} />

    case 'radial-bar':
      return <RadialBarConfiguration {...props} />

    // Tendencias
    case 'area-chart':
      return <AreaChartConfiguration {...props} />

    // Comparación
    case 'stacked-bar':
      return <StackedBarConfiguration {...props} />

    case 'radar-chart':
      return <RadarChartConfiguration {...props} />

    // Análisis
    case 'scatter-plot':
      return <ScatterPlotConfiguration {...props} />

    case 'heatmap':
      return <HeatmapConfiguration {...props} />

    default:
      return (
        <div className="text-center py-12">
          <p className="text-gray-500">
            Tipo de componente no reconocido. Por favor vuelve atrás.
          </p>
          <button
            onClick={props.onPrev}
            className="mt-4 text-green-600 hover:underline"
          >
            ← Volver
          </button>
        </div>
      )
  }
}
